module.exports = __webpack_public_path__ + "img/equipos-de-sala-img-3.c401fbb1.jpg";